import { useState } from "react";
import { cn } from "@/lib/utils";

const R = 230;
const C = 300;

export const DisciplineMap = ({ disciplines }) => {
  const [active, setActive] = useState(null);
  const n = disciplines.length;
  const pts = disciplines.map((d, i) => {
    const a = (i / n) * Math.PI * 2 - Math.PI / 2;
    return { ...d, x: C + R * Math.cos(a), y: C + R * Math.sin(a), right: Math.cos(a) > 0.2, left: Math.cos(a) < -0.2 };
  });
  const lit = (i, j) => active === null || active === i || active === j;
  return (
    <div className="relative" data-testid="discipline-map">
      <svg viewBox="-80 0 760 600" className="w-full overflow-visible" role="img" aria-label={`Discipline map connecting ${disciplines.map((d) => d.title).join(", ")}`}>
        <circle cx={C} cy={C} r={R} fill="none" stroke="rgb(var(--line) / 0.12)" strokeDasharray="2 6" />
        <circle cx={C} cy={C} r={R * 0.55} fill="none" stroke="rgb(var(--gold) / 0.25)" />
        {pts.map((p, i) =>
          pts.slice(i + 1).map((q, k) => {
            const j = i + 1 + k;
            const on = active !== null && lit(i, j);
            return <line key={`${i}-${j}`} x1={p.x} y1={p.y} x2={q.x} y2={q.y} stroke={on ? "rgb(var(--turq))" : "rgb(var(--line) / 0.1)"} strokeWidth={on ? 1.4 : 0.8} style={{ transition: "stroke 0.4s ease" }} />;
          })
        )}
        {pts.map((p, i) => (
          <line key={`c${i}`} x1={C} y1={C} x2={p.x} y2={p.y} stroke="rgb(var(--gold) / 0.35)" strokeWidth="0.8" />
        ))}
        <circle cx={C} cy={C} r="52" fill="rgb(var(--canvas))" stroke="rgb(var(--gold))" />
        <text x={C} y={C + 6} textAnchor="middle" className="font-display" fontSize="22" fill="rgb(var(--fg))">Lutazzi</text>
        {pts.map((p, i) => (
          <g
            key={p.title}
            tabIndex={0}
            role="button"
            aria-label={`${p.title}: ${p.description}`}
            data-testid={`discipline-node-${i}`}
            onMouseEnter={() => setActive(i)}
            onMouseLeave={() => setActive(null)}
            onFocus={() => setActive(i)}
            onBlur={() => setActive(null)}
            className="cursor-pointer outline-none"
          >
            <circle cx={p.x} cy={p.y} r={active === i ? 13 : 8} fill={active === i ? "rgb(var(--turq))" : "rgb(var(--canvas))"} stroke="rgb(var(--turq))" strokeWidth="1.5" style={{ transition: "r 0.3s ease, fill 0.3s ease" }} />
            <text
              x={p.x + (p.right ? 22 : p.left ? -22 : 0)}
              y={p.y + (p.right || p.left ? 6 : p.y < C ? -24 : 34)}
              textAnchor={p.right ? "start" : p.left ? "end" : "middle"}
              fontSize="19"
              className="font-sans"
              fill={active === i ? "rgb(var(--turq))" : "rgb(var(--fg))"}
            >
              {p.title}
            </text>
          </g>
        ))}
      </svg>
      <p className={cn("label-mono mt-4 min-h-[1.5em] text-center transition-opacity", active === null && "opacity-60")} aria-live="polite">
        {active === null ? "Hover or focus a discipline" : `${pts[active].title} — ${pts[active].description}`}
      </p>
    </div>
  );
};
